/**
 * The props of a radio group that holds one of its options: the chosen one, and the option
 * picked handed back, never a bare key.
 */
export function radioChoice(options, value, onChange) {
    return {
        value,
        onChange: (next) => {
            const chosen = options.find((o) => o.id === next);
            if (chosen)
                onChange(chosen.id);
        },
    };
}
/**
 * The props of a toggle group that holds one of its options (`ToggleButtonGroup`): the option
 * chosen - none for `null` - and the option pressed handed back, never a bare key.
 */
export function singleChoice(options, value, onChange) {
    return {
        selectionMode: 'single',
        selectedKeys: value === null ? [] : [value],
        onSelectionChange: (keys) => {
            const [next] = [...keys];
            const option = options.find((o) => o.id === next);
            if (option)
                onChange(option.id);
        },
    };
}
//# sourceMappingURL=single-choice.js.map